module.exports = __webpack_public_path__ + "static/media/pay.4ea3d7dc.jpg";